module.exports = __webpack_public_path__ + "static/media/fly0044.afdedf90.webp";